// import React, { useState, useEffect } from 'react';
// import { Pie } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import { motion } from 'framer-motion';
// import FAQSchema from '../../FAQSchema';
// import AdBanner from '../AdPage/AdBanner';
// // Register necessary components
// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend
// );

// const LumpsumCalculator = ({ isSip, setIsSip }) => {
//   const [lumpsumInvestment, setLumpsumInvestment] = useState(100000);
//   const [expectedReturnRate, setExpectedReturnRate] = useState(12);
//   const [timePeriod, setTimePeriod] = useState(10);
//   const [totalReturns, setTotalReturns] = useState(0);
//   const [estimatedReturns, setEstimatedReturns] = useState(0);

//   useEffect(() => {
//     calculateReturns();
//   }, [lumpsumInvestment, expectedReturnRate, timePeriod]);

//   const calculateReturns = () => {
//     if (lumpsumInvestment <= 0 || expectedReturnRate <= 0 || timePeriod <= 0) return;
    
//     const rate = expectedReturnRate / 100;
//     const total = lumpsumInvestment * Math.pow(1 + rate, timePeriod);
//     const estimated = total - lumpsumInvestment;
//     setTotalReturns(total.toFixed(2));
//     setEstimatedReturns(estimated.toFixed(2));
//   };

//   const handleInvestmentChange = (e) => {
//     const value = e.target.value;
//     setLumpsumInvestment(value === '' ? 0 : parseInt(value));
//   };

//   const handleExpectedReturnRateChange = (e) => {
//     const value = e.target.value;
//     setExpectedReturnRate(value === '' ? 0 : parseFloat(value));
//   };

//   const handleTimePeriodChange = (e) => {
//     const value = e.target.value;
//     setTimePeriod(value === '' ? 0 : parseInt(value));
//   };

//   const data = {
//     labels: ['Total Investment', 'Estimated Returns'],
//     datasets: [
//       {
//         label: 'Lumpsum Returns Breakdown',
//         data: [lumpsumInvestment, estimatedReturns],
//         backgroundColor: ['#36A2EB', '#FF6384'],
//       },
//     ],
//   };
//  function Icon({ id, open }) {
//     return (
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth={2}
//             stroke="currentColor"
//             className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
//         >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//         </svg>
//     );
//   }
  
  
//     const [activeIndex, setActiveIndex] = useState(0);
  
     
//     const faqs = [
//       {
//         question: 'What is a Lump Sum investment in mutual funds?',
//         answer:
//           'A lump sum investment involves investing a large amount of money at once into a mutual fund scheme rather than spreading it over time through SIPs.',
//       },
//       {
//         question: 'Who should choose lump sum investing?',
//         answer:
//           'It\'s ideal for those with a surplus amount available—such as from a bonus, sale of property, inheritance, or matured FDs—and who are confident in market timing or willing to stay invested long-term.',
//       },
//       {
//         question: 'Can I invest a lump sum during a market high?',
//         answer:
//           'Yes, but it’s riskier. Market highs may precede corrections. If uncertain, consider STPs (Systematic Transfer Plans) to stagger your lump sum investment into equity funds over time.',
//       },
//       {
//         question: 'What is a lump sum calculator used for?',
//         answer:
//           'To estimate how much your one-time investment will grow over a selected time frame and expected return rate.',
//       },
//       {
//         question: 'Is the maturity amount shown in calculators guaranteed?',
//         answer:
//           'No, it\'s an estimate based on assumed return rates. Market conditions can affect actual returns.',
//       },
//       {
//         question: 'How do I choose the return rate to input?',
//         answer:
//           'Check the historical average return of your chosen mutual fund. For equity funds, use 10–12%, for debt funds 6–8%.',
//       },
//       {
//         question: 'What does compounding frequency mean in lump sum calculators?',
//         answer:
//           'It’s how often the returns are compounded annually—monthly, quarterly, or semi-annually. More frequent compounding typically yields higher returns.',
//       },
//       {
//         question: 'Does the calculator account for taxes and charges?',
//         answer:
//           'No, it provides gross returns only. Exit loads, capital gains tax, and expense ratios are not included in the calculation.',
//       },
//       {
//         question: 'Is it better to invest lump sum in equity or debt funds?',
//         answer:
//           'Equity funds offer higher potential returns over time but with more risk. Debt funds are safer and more stable. Your risk tolerance and goal duration should guide this choice.',
//       },
//       {
//         question: 'Can I withdraw money before the investment tenure ends?',
//         answer:
//           'Yes, but check for exit loads or short-term capital gains tax, especially for equity mutual funds.',
//       },
//       {
//         question: 'What is CAGR and how is it different from absolute return?',
//         answer:
//           'CAGR (Compound Annual Growth Rate) shows annualized returns, giving a clearer picture for long-term performance, while absolute return only shows the total growth regardless of time.',
//       },
//       {
//         question: 'Can I invest in multiple mutual funds through lump sum?',
//         answer:
//           'Yes. You can divide your lump sum across different schemes or asset classes to diversify risk.',
//       },
//       {
//         question: 'What is a good tenure for lump sum investing?',
//         answer:
//           'For equity funds, a minimum of 5 years is recommended. For debt funds, even 1–3 years may suffice, depending on interest rate cycles.',
//       },
//       {
//         question: 'Can I use both SIP and lump sum methods together?',
//         answer:
//           'Absolutely. You can start with a lump sum and then add SIPs for future contributions to the same fund or different ones.',
//       },
//       {
//         question: 'Is it safe to invest a lump sum in mutual funds?',
//         answer:
//           'It carries market risk, especially in the short term. But with proper research and a long-term horizon, it can be a powerful wealth-building strategy.',
//       },
//     ];
    
    
//     const toggleAccordion = (index) => {
//       if (activeIndex === index) {
//           // If the clicked question is already expanded, collapse it
//           setActiveIndex(null);
//       } else {
//           // If the clicked question is not expanded, expand it
//           setActiveIndex(index);
//       };
//     }
//     const calculators = [
//       {
//         name: 'HDFC SIP Calculator',
//         path: '/financial-tools-calculators/hdfc-sip-calculator',
//         image: '/assets/siphd.png',
//       },
//       {
//         name: 'ICICI SIP Calculator',
//         path: '/financial-tools-calculators/icici-sip-calculator',
//         image: '/assets/ic.png',
//       },
//       {
//         name: 'Axis SIP Calculator',
//         path: '/financial-tools-calculators/axis-sip-calculator',
//         image: '/assets/axis.png',
//       },
//       {
//         name: 'Kotak SIP Calculator',
//         path: '/financial-tools-calculators/kotak-sip-calculator',
//         image: '/assets/kot.png',
//       },
//       {
//         name: 'Canara SIP Calculator',
//         path: '/financial-tools-calculators/canara-bank-sip-calculator',
//         image: '/assets/can.png',
//       },
//       {
//         name: 'SBI SIP Calculator',
//         path: '/financial-tools-calculators/sbi-bank-sip-calculator',
//         image: '/assets/sb.png',
//       },
//       {
//         name: 'Nippon SIP Calculator',
//         path: '/financial-tools-calculators/nippon-bank-sip-calculator',
//         image: '/assets/nipp.png',
//       },
//       {
//         name: 'LIC SIP Calculator',
//         path: '/financial-tools-calculators/lic-bank-sip-calculator',
//         image: '/assets/lic.png',
//       },
//       {
//         name: 'PNB SIP Calculator',
//         path: '/financial-tools-calculators/pnb-bank-sip-calculator',
//         image: '/assets/pn.png',
//       },
//       {
//         name: 'IDBI SIP Calculator',
//         path: '/financial-tools-calculators/idbi-bank-sip-calculator',
//         image: '/assets/id.png',
//       },
//     ];
//   return (
//     <>
//       <Helmet>
//         <title>Lumpsum Calculator – Mutual Fund Investment Return Calculator</title>
//         <meta name='description' content='Calculate the future value of your one-time mutual fund investment with our easy-to-use lumpsum calculator.' />
//         <meta name='keywords' content='lump sum sip calculator, mutual fund calculator lumpsum, lumpsum investment calculator' />
//         <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/lumpsum-calculator" />
//         <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
//         <meta name="robots" content="max-video-preview:-1" />
//       </Helmet>
//       <FAQSchema faqs={faqs} />
//       {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
//       <ol className="list-none p-0 inline-flex">
//         <li className="flex items-center">
//           <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//         <li className="flex items-center">
//           <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//           <li className="flex items-center">
//           <span className="text-gray-500 ">Lumpsum Calculator</span>
//         </li> 
      
//       </ol>
//     </nav> */}
//         <div className="w-full flex justify-center items-center px-4 mt-20">
//       <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
//       <AdBanner displayOrder="1" />
//       </div>
//     </div>
//       <div className='py-6'>
//         <div className="container mx-auto p-4 shadow-xl rounded-md ">
//           <div className="flex space-x-4 mb-4">
//             <button
//               className={`py-2 px-4 rounded-md ${isSip ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
//               onClick={() => setIsSip(true)}
//             >
//               SIP
//             </button>
//             <button
//               className={`py-2 px-4 rounded-md ${!isSip ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
//               onClick={() => setIsSip(false)}
//             >
//               Lumpsum
//             </button>
//           </div>
//           <h2 className="text-2xl font-bold mb-4">Lumpsum Returns Calculator</h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
//             <div>
//               <div className="mb-4">
//                 <label className="block text-gray-700 font-semibold">Total Investment</label>
//                 <div className="flex items-center">
//                   <input
//                     type="number"
//                     min="0"
//                     max="10000000"
//                     value={lumpsumInvestment}
//                     onChange={handleInvestmentChange}
//                     className="w-1/2 p-2 border rounded mr-2"
//                   />
//                   <span className="text-gray-700">₹ {lumpsumInvestment.toLocaleString()}</span>
//                 </div>
//                 <input
//                   type="range"
//                   min="0"
//                   max="10000000"
//                   value={lumpsumInvestment}
//                   onChange={(e) => setLumpsumInvestment(parseInt(e.target.value))}
//                   className="w-full mt-2"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-gray-700 font-semibold">Expected Return Rate (P.A.)</label>
//                 <div className="flex items-center">
//                   <input
//                     type="number"
//                     min="0"
//                     max="100"
//                     step="0.1"
//                     value={expectedReturnRate}
//                     onChange={handleExpectedReturnRateChange}
//                     className="w-1/2 p-2 border rounded mr-2"
//                   />
//                   <span className="text-gray-700">{expectedReturnRate} %</span>
//                 </div>
//                 <input
//                   type="range"
//                   min="0"
//                   max="100"
//                   step="0.1"
//                   value={expectedReturnRate}
//                   onChange={(e) => setExpectedReturnRate(parseFloat(e.target.value))}
//                   className="w-full mt-2"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-gray-700 font-semibold">Time Period (Years)</label>
//                 <div className="flex items-center">
//                   <input
//                     type="number"
//                     min="1"
//                     max="50"
//                     value={timePeriod}
//                     onChange={handleTimePeriodChange}
//                     className="w-1/2 p-2 border rounded mr-2"
//                   />
//                   <span className="text-gray-700">{timePeriod} Yr</span>
//                 </div>
//                 <input
//                   type="range"
//                   min="1"
//                   max="50"
//                   value={timePeriod}
//                   onChange={(e) => setTimePeriod(parseInt(e.target.value))}
//                   className="w-full mt-2"
//                 />
//               </div>
//               {/* You can remove this button if you prefer automatic calculation */}
//               <button
//                 onClick={calculateReturns}
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//               >
//                 Calculate
//               </button>
//             </div>
//             <div>
//               <div className="mb-4">
//                 <h2 className="text-xl font-bold">Results</h2>
//                 <p>Total Investment: ₹ {lumpsumInvestment.toLocaleString()}</p>
//                 <p>Estimated Returns: ₹ {estimatedReturns.toLocaleString()}</p>
//                 <p>Total Returns: ₹ {totalReturns.toLocaleString()}</p>
//               </div>
//               <div>
//                 <h2 className="text-xl font-bold">Breakdown</h2>
//                 <div className="flex justify-center">
//                   <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const LumpsumCalculator = ({ isSip, setIsSip }) => {
  const [lumpsumInvestment, setLumpsumInvestment] = useState(100000);
  const [expectedReturnRate, setExpectedReturnRate] = useState(12);
  const [timePeriod, setTimePeriod] = useState(10);
  const [totalReturns, setTotalReturns] = useState(0);
  const [estimatedReturns, setEstimatedReturns] = useState(0);
  const [isCalculated, setIsCalculated] = useState(false);

  // Removed useEffect - no automatic calculation

  const calculateReturns = () => {
    if (lumpsumInvestment <= 0 || expectedReturnRate <= 0 || timePeriod <= 0) {
      alert('Please enter valid positive values for all fields.');
      return;
    }
    
    const rate = expectedReturnRate / 100;
    const total = lumpsumInvestment * Math.pow(1 + rate, timePeriod);
    const estimated = total - lumpsumInvestment;
    setTotalReturns(total.toFixed(2));
    setEstimatedReturns(estimated.toFixed(2));
    setIsCalculated(true);
  };

  const handleInvestmentChange = (e) => {
    const value = e.target.value;
    setLumpsumInvestment(value === '' ? 0 : parseInt(value));
    setIsCalculated(false); // Reset calculation status when input changes
  };

  const handleExpectedReturnRateChange = (e) => {
    const value = e.target.value;
    setExpectedReturnRate(value === '' ? 0 : parseFloat(value));
    setIsCalculated(false); // Reset calculation status when input changes
  };

  const handleTimePeriodChange = (e) => {
    const value = e.target.value;
    setTimePeriod(value === '' ? 0 : parseInt(value));
    setIsCalculated(false); // Reset calculation status when input changes
  };

  const data = {
    labels: ['Total Investment', 'Estimated Returns'],
    datasets: [
      {
        label: 'Lumpsum Returns Breakdown',
        data: [lumpsumInvestment, parseFloat(estimatedReturns)],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };

  function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  const [activeIndex, setActiveIndex] = useState(0);
  
  const faqs = [
    {
      question: 'What is a Lump Sum investment in mutual funds?',
      answer:
        'A lump sum investment involves investing a large amount of money at once into a mutual fund scheme rather than spreading it over time through SIPs.',
    },
    {
      question: 'Who should choose lump sum investing?',
      answer:
        'It\'s ideal for those with a surplus amount available—such as from a bonus, sale of property, inheritance, or matured FDs—and who are confident in market timing or willing to stay invested long-term.',
    },
    {
      question: 'Can I invest a lump sum during a market high?',
      answer:
        'Yes, but it is  riskier. Market highs may precede corrections. If uncertain, consider STPs (Systematic Transfer Plans) to stagger your lump sum investment into equity funds over time.',
    },
    {
      question: 'What is a lump sum calculator used for?',
      answer:
        'To estimate how much your one-time investment will grow over a selected time frame and expected return rate.',
    },
    {
      question: 'Is the maturity amount shown in calculators guaranteed?',
      answer:
        'No, it\'s an estimate based on assumed return rates. Market conditions can affect actual returns.',
    },
    {
      question: 'How do I choose the return rate to input?',
      answer:
        'Check the historical average return of your chosen mutual fund. For equity funds, use 10–12%, for debt funds 6–8%.',
    },
    {
      question: 'What does compounding frequency mean in lump sum calculators?',
      answer:
        'It is  how often the returns are compounded annually—monthly, quarterly, or semi-annually. More frequent compounding typically yields higher returns.',
    },
    {
      question: 'Does the calculator account for taxes and charges?',
      answer:
        'No, it provides gross returns only. Exit loads, capital gains tax, and expense ratios are not included in the calculation.',
    },
    {
      question: 'Is it better to invest lump sum in equity or debt funds?',
      answer:
        'Equity funds offer higher potential returns over time but with more risk. Debt funds are safer and more stable. Your risk tolerance and goal duration should guide this choice.',
    },
    {
      question: 'Can I withdraw money before the investment tenure ends?',
      answer:
        'Yes, but check for exit loads or short-term capital gains tax, especially for equity mutual funds.',
    },
    {
      question: 'What is CAGR and how is it different from absolute return?',
      answer:
        'CAGR (Compound Annual Growth Rate) shows annualized returns, giving a clearer picture for long-term performance, while absolute return only shows the total growth regardless of time.',
    },
    {
      question: 'Can I invest in multiple mutual funds through lump sum?',
      answer:
        'Yes. You can divide your lump sum across different schemes or asset classes to diversify risk.',
    },
    {
      question: 'What is a good tenure for lump sum investing?',
      answer:
        'For equity funds, a minimum of 5 years is recommended. For debt funds, even 1–3 years may suffice, depending on interest rate cycles.',
    },
    {
      question: 'Can I use both SIP and lump sum methods together?',
      answer:
        'Absolutely. You can start with a lump sum and then add SIPs for future contributions to the same fund or different ones.',
    },
    {
      question: 'Is it safe to invest a lump sum in mutual funds?',
      answer:
        'It carries market risk, especially in the short term. But with proper research and a long-term horizon, it can be a powerful wealth-building strategy.',
    },
  ];
    
  const toggleAccordion = (index) => {
    if (activeIndex === index) {
        setActiveIndex(null);
    } else {
        setActiveIndex(index);
    }
  };

  const calculators = [
    {
      name: 'HDFC SIP Calculator',
      path: '/financial-tools-calculators/hdfc-sip-calculator',
      image: '/assets/siphd.png',
    },
    {
      name: 'ICICI SIP Calculator',
      path: '/financial-tools-calculators/icici-sip-calculator',
      image: '/assets/ic.png',
    },
    {
      name: 'Axis SIP Calculator',
      path: '/financial-tools-calculators/axis-sip-calculator',
      image: '/assets/axis.png',
    },
    {
      name: 'Kotak SIP Calculator',
      path: '/financial-tools-calculators/kotak-sip-calculator',
      image: '/assets/kot.png',
    },
    {
      name: 'Canara SIP Calculator',
      path: '/financial-tools-calculators/canara-bank-sip-calculator',
      image: '/assets/can.png',
    },
    {
      name: 'SBI SIP Calculator',
      path: '/financial-tools-calculators/sbi-bank-sip-calculator',
      image: '/assets/sb.png',
    },
    {
      name: 'Nippon SIP Calculator',
      path: '/financial-tools-calculators/nippon-bank-sip-calculator',
      image: '/assets/nipp.png',
    },
    {
      name: 'LIC SIP Calculator',
      path: '/financial-tools-calculators/lic-bank-sip-calculator',
      image: '/assets/lic.png',
    },
    {
      name: 'PNB SIP Calculator',
      path: '/financial-tools-calculators/pnb-bank-sip-calculator',
      image: '/assets/pn.png',
    },
    {
      name: 'IDBI SIP Calculator',
      path: '/financial-tools-calculators/idbi-bank-sip-calculator',
      image: '/assets/id.png',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Lumpsum Calculator – Mutual Fund Investment Return Calculator</title>
        <meta name='description' content='Calculate the future value of your one-time mutual fund investment with our easy-to-use lumpsum calculator.' />
        <meta name='keywords' content='lump sum sip calculator, mutual fund calculator lumpsum, lumpsum investment calculator' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/lumpsum-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      
      <div className="w-full flex justify-center items-center px-4 mt-20">
        <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
          <AdBanner displayOrder="1" />
        </div>
      </div>
      
      <div className='py-6'>
        <div className="container mx-auto p-4 shadow-xl rounded-md">
          <div className="flex space-x-4 mb-4">
            <button
              className={`py-2 px-4 rounded-md ${isSip ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              onClick={() => setIsSip(true)}
            >
              SIP
            </button>
            <button
              className={`py-2 px-4 rounded-md ${!isSip ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              onClick={() => setIsSip(false)}
            >
              Lumpsum
            </button>
          </div>
          
                    <h1 className="text-2xl font-bold mb-4">Lumpsum Returns Calculator</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div>
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold">Total Investment</label>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="0"
                    max="10000000"
                    value={lumpsumInvestment}
                    onChange={handleInvestmentChange}
                    className="w-1/2 p-2 border rounded mr-2"
                  />
                  <span className="text-gray-700">₹ {lumpsumInvestment.toLocaleString()}</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="10000000"
                  value={lumpsumInvestment}
                  onChange={(e) => {
                    setLumpsumInvestment(parseInt(e.target.value));
                    setIsCalculated(false);
                  }}
                  className="w-full mt-2"
                />
              </div>
              
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold">Expected Return Rate (P.A.)</label>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={expectedReturnRate}
                    onChange={handleExpectedReturnRateChange}
                    className="w-1/2 p-2 border rounded mr-2"
                  />
                  <span className="text-gray-700">{expectedReturnRate} %</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  step="0.1"
                  value={expectedReturnRate}
                  onChange={(e) => {
                    setExpectedReturnRate(parseFloat(e.target.value));
                    setIsCalculated(false);
                  }}
                  className="w-full mt-2"
                />
              </div>
              
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold">Time Period (Years)</label>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="1"
                    max="50"
                    value={timePeriod}
                    onChange={handleTimePeriodChange}
                    className="w-1/2 p-2 border rounded mr-2"
                  />
                  <span className="text-gray-700">{timePeriod} Yr</span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={timePeriod}
                  onChange={(e) => {
                    setTimePeriod(parseInt(e.target.value));
                    setIsCalculated(false);
                  }}
                  className="w-full mt-2"
                />
              </div>
              
              <button
                onClick={calculateReturns}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
              >
                Calculate
              </button>
            </div>
            
            <div>
              {isCalculated ? (
                <>
                  <div className="mb-4">
                    <h2 className="text-xl font-bold">Results</h2>
                    <p>Total Investment: ₹ {lumpsumInvestment.toLocaleString()}</p>
                    <p>Estimated Returns: ₹ {parseFloat(estimatedReturns).toLocaleString()}</p>
                    <p>Total Value: ₹ {parseFloat(totalReturns).toLocaleString()}</p>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">Breakdown</h2>
                    <div className="flex justify-center">
                      <Pie
                        data={data}
                        options={{ maintainAspectRatio: false }}
                        width={300}
                        height={300}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-center h-full">
                  <p className="text-gray-500 text-lg">
                    Click "Calculate" to see your Lumpsum results
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 sm:p-8 bg-white">
      <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center">
      LumpSum SIP Calculator 
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {calculators.map((calc, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.04 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
          >
            <Link
              to={calc.path}
              className="flex flex-col items-center justify-center text-center border border-gray-200 rounded-lg p-3 bg-white shadow-sm hover:shadow-md transition-all duration-300 h-full min-h-[140px]"
            >
              <img
                src={calc.image}
                alt={calc.name}
                className="w-10 h-10 object-contain mb-2"
              />
              <span className="text-md font-medium text-gray-800 break-words leading-snug">
                {calc.name}
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
      <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
      <div className="w-full md:w-2/3 p-2">
  <div className="container mx-auto py-2">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      Understanding Lump Sum Investment: A Direct Route to Mutual Fund Growth
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
    A lump sum investment is a one-time investment of a considerable amount into a mutual fund scheme. Unlike SIPs, where money is invested gradually over time, lump sum investing is ideal when you have surplus capital ready to deploy—be it from a bonus, inheritance, or savings. This method leverages the power of compounding from day one, as your entire amount starts working for you immediately.    </p>
  </div>
  <div className="container mx-auto py-2">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 mt-6">
      Mutual Funds : SIPs vs Lump Sum — What’s the Difference?
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      While both are methods to invest in mutual funds, SIPs spread your investment over time, potentially reducing risk through rupee-cost averaging. In contrast, lump sum investing may offer higher returns when the market is favorable, as a larger amount is invested upfront.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      <span className="font-bold">Best use cases :</span>
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      SIP : For salaried individuals or market volatility
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      LumpSum : When you foresee long-term market stability or have a large corpus
    </p>
  </div>
  <div className="container mx-auto py-4">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      What is a LumpSum Calculator? Your Investment Estimation Tool
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      A LumpSum calculator helps you project your future returns from a one-time mutual fund investment. It simplifies financial planning by estimating the maturity amount based on your initial capital, expected annual return, investment duration, and compounding frequency.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      This tool is ideal for:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Investors with windfall gains
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Goal-based planning (like education, retirement, property)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Those comparing lump sum vs SIP outcomes
    </p>
  </div>
  {/* <div className="container mx-auto py-4">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      Important Note: Estimates and Transparency
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      While LumpSum calculators provide valuable insight, it's crucial to understand that these are estimates, not guarantees. Actual returns from mutual fund investments can vary due to:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Market fluctuations
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Fund performance
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Inflation
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Management fees and fund expenses
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      Also, most calculators do not account for:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Exit loads (fees for early withdrawal)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Expense ratios (annual fees charged by mutual funds)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      Therefore, while a calculator is an excellent starting point, you should also review the scheme details, risk factors, and consult a financial advisor if needed for personalized advice.
    </p>
  </div> */}
  <div className="container mx-auto py-4">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      Understanding LumpSum Returns: Breaking Down Return Types
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      To make informed decisions, it's essential to grasp how returns are measured in lump sum investing. Here are the key metrics:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Absolute Return :</span> The total increase in value from your initial investment, without accounting for time.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Total Return :</span> Includes both capital appreciation and reinvested dividends.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Annualized Return (CAGR) :</span> Reflects the average rate of return per year.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Point-to-Point Return :</span> Measures growth between two fixed calendar dates.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Rolling Return :</span> Measures average return for a fixed period across overlapping intervals to indicate consistency.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Trailing Return :</span> Shows return from a past point (1-year, 3-year) to today.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      Each return metric offers unique insight into fund performance over time and under different market conditions.
    </p>
  </div>
  <div className="container mx-auto py-4">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      Benefits of Using a LumpSum Calculator
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Visualize Growth Potential :</span> Get a projection of your corpus based on real numbers.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Clarity for Goal Planning :</span> Align investments with milestones like retirement or a child’s education.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Compare Scenarios Easily :</span> Adjust values like return rate or tenure to see varied outcomes.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Beginner Friendly :</span> Designed for all levels of investors—no finance background needed.
    </p>
  </div>
  <div className="container mx-auto py-4">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      The Math Behind LumpSum Calculations: Understanding the Formula
    </h2>
    <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
      LumpSum investments grow through compound interest, and the calculator uses this formula:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      A = P × (1 + r/n)^(nt)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      A = Estimated Future Value (Maturity Amount)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      P = Initial Investment (Principal)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      r = Annual rate of return (decimal form)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      t = Time (in years)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      n = Number of times interest is compounded annually
    </p>
  </div>
  <div className="container mx-auto py-4">
    {/* <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      <span className="font-bold">Example Calculation</span>
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      Let’s assume:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Investment = ₹15,00,000
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Annual expected return = 12%
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Duration = 5 years
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Compounding = Semi-annually
    </p> */}
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
    Illustration:
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
    If you invest ₹15,00,000 at an expected 12% annual return for 5 years (semi-annual compounding)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      P = ₹15,00,000
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      r = 0.12
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      n = 2
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      t = 5
    </p>
    <p className="text-xl font-medium pl-4 py-2 text-gray-600">
    Using the formula:
    </p>
    <p className="text-xl font-medium pl-4 py-2 text-gray-600">
      A = 15,00,000 × (1 + 0.06)^10 ≈ ₹26,43,513
    </p>
    {/* <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
      This showcases how your money grows through the power of compounding, where your entire investment starts earning returns from day one.
    </p> */}
  </div>
   <div className="w-full flex justify-center items-center my-6 px-4">
            <div className="w-full max-w-[984px]">
  
       
          <AdBanner displayOrder="3" />
          </div>
           
          </div>
  <div className="container mx-auto py-4">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
      TheFinMaster tool is intuitive and accessible. Here's how to use it:
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
    TheFinMaster tool is intuitive and accessible. Here's how to use it:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Input your investment amount (P)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Select your expected return rate (r) using a slider or typing it
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Choose the number of years (t)
    </p>
    
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Select compounding frequency (optional: annually, semi-annually, quarterly)
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      Get your result: The calculator shows the estimated maturity amount instantly

    </p>
    
  </div>
  <div className="container mx-auto py-2">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 mt-6">
      TheFinMaster LumpSum Calculator: Your Investment Ally
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
    With our tool, you’re not just doing math—you’re making informed decisions. Here’s how we help:
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Instant Results :</span> No spreadsheets, no manual calculation errors.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Realistic Forecasting :</span> A practical return estimate for planning big-ticket expenses.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Time Efficiency :</span> Spend less time calculating and more time planning.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Accessibility :</span> Works seamlessly on desktop and mobile.
    </p>
  </div>
  <div className="container mx-auto py-2">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 mt-6">
    Why Choose Lump Sum Investment? Long-Term Wealth Building at Scale
    </h2>
   
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Compounding Powernstant Results :</span> Your entire investment starts earning returns from day one.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Ideal for Market Dips :</span> A lump sum during a downturn can yield strong returns as the market recovers.
    </p>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6">
      <span className="absolute left-0 top-0 text-blue-600">•</span>
      <span className="font-bold">Simplicity :</span>  No recurring payments—invest once and track growth.
    </p>
   
  </div>
  <div className="container mx-auto py-2">
    <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 mt-6">
      Start Investing Today: Let Your Idle Funds Work Harder
    </h2>
    <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
      If you have idle funds lying in savings accounts or FDs, consider reallocating a portion into mutual funds via a lump sum route. With calculators and planning tools like TheFinMaster’s, you reduce guesswork and invest with clarity and confidence.
    </p>
   
  </div>
</div>

        <div className="w-full md:w-1/3 p-4">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
              <h2 className="text-lg font-semibold ">Popular Categories</h2>
            </div>
            <div className="p-2 ">
              <ul>
                <Link to='/financial-tools-calculators/swp-calculator'>
                  <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/fd-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/rd-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/nps-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/emi-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>

                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                </Link>
                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
              </ul>
            </div>
          </div>
                     {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
          <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
              <h2 className="text-lg font-semibold">More Categories</h2>
            </div>
            <div className="p-2">
              <ul>
                <Link to='/financial-tools-calculators/gratuity-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/APY-calculator'>
                  <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/cagr-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/gst-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                </Link>
                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                </Link> */}
                <Link to='/financial-tools-calculators/inflation-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/salary-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/brokerage-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                </Link>
                <Link to='/financial-tools-calculators/tds-calculator'>
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                </Link>
                {/* {moreCategories.map(category => (
          <Link key={category.id} to={`/category/${category.id}`}>
            <li className="py-2 border-b border-gray-300">{category.name}</li>
          </Link>
        ))} */}
              </ul>
            </div>
          </div>

        </div>

      </div>
         {/* FAQ section */}
    <div className="max-w-4xl mx-auto py-6 mt-10 px-2">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default LumpsumCalculator;
